import type { MatterLien } from "@/lib/types";

type LienForTotals = Pick<MatterLien, "status"> & {
  negotiatedAmount?: MatterLien["negotiatedAmount"] | string;
  originalAmount?: MatterLien["originalAmount"] | string;
  paidAmount?: MatterLien["paidAmount"] | string;
};

const toFiniteNumber = (value: unknown) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) {
    return null;
  }

  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : null;
};

const getLienAmount = (lien: LienForTotals) =>
  toFiniteNumber(lien.negotiatedAmount) ??
  toFiniteNumber(lien.originalAmount) ??
  0;

export const calculateLienTotals = (liens: LienForTotals[]) => {
  const unpaidLiensCount = liens.filter(
    (lien) => lien.status !== "Paid",
  ).length;
  const totalLiens = liens.reduce((acc, lien) => acc + getLienAmount(lien), 0);
  const unpaidLiensAmount = liens
    .filter((lien) => lien.status !== "Paid")
    .reduce(
      (acc, lien) =>
        acc + getLienAmount(lien) - (toFiniteNumber(lien.paidAmount) ?? 0),
      0,
    );
  return {
    totalLiens,
    unpaidLiensAmount,
    unpaidLiensCount,
  };
};
